import { render, staticRenderFns } from "./OccupationAreasTable.vue?vue&type=template&id=432256c0"
import script from "./OccupationAreasTable.vue?vue&type=script&lang=js"
export * from "./OccupationAreasTable.vue?vue&type=script&lang=js"
import style0 from "./OccupationAreasTable.vue?vue&type=style&index=0&id=432256c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports